import Vue from 'vue';
import { Component, Prop, Provide, Watch } from 'vue-property-decorator';
import * as Logger from 'js-logger';

import { join, forEach, groupBy, find, head, map } from 'lodash-es';
import StageHeader from '../../components/stageHeader';
import UinsDefaultSelect from '../../components/unisDefaultSelect';
import template from './viewShipment.vue';
import MainButtonSet from '../../components/mainButtonSet';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import PayBalance from '../../components/payBalance';

@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UinsDefaultSelect,
        UnisProductModal,
        PayBalance,
    },
})
export default class ViewShipment extends Vue {
    myAccountData: any = this.$store.getters.myAccountData;
    truckloadForm: any = {};
    editProductModal: string = 'payBalance';
    foldBody: number = 0;
    invoiceId: String = '';
    invoiceInfo: any = {};
    showErrTip: boolean = false;
    errorText: String = '';
    payTitle: string = 'Pay for invoices';
    payOptionVal: any = 1;
    outstandingList: any = [];
    payInvoice: any = [];

    created() {
        this.init();
    }

    mounted() {
        // this.$modal.show(this.editProductModal);
    }

    init() {
        this.invoiceId = this.$route.params.id;
        this.getInvoiceInfo();
    }

    editProductAction(modalName: any) {
        this.editProductModal = modalName;
        this.$modal.show(modalName);
    }
    closeModal() {
        if (this.payInvoice.length >= 1) {
            this.payInvoice = [];
        }
        this.$modal.hide(this.editProductModal);
    }
    saveProduct() {
        // this.validate();
    }

    getInvoiceInfo() {
        tmsServiceBackend
            .get(
                `/tms/invoices/${this.invoiceId}/detail?billto_id=${localStorage.getItem(
                    'BillToId'
                )}`
            )
            .then(
                (res: any) => {
                    this.invoiceInfo = res.data.data;
                    /*let qutstandingBalance: number = 0;
                if (this.invoiceInfo.payment_lines.length > 0) {
                    forEach(this.invoiceInfo.payment_lines, (line) => {
                        if (line.paid_amount != 'undefined') {
                            qutstandingBalance = qutstandingBalance + Number(line.paid_amount);
                        }
                        if (line.balance != 'undefined' && line.paid_amount != 'undefined') {
                            line['balance_due'] = Number(line.balance) - Number(line.paid_amount);
                        }
                    });
                }
                this.invoiceInfo['qutstanding_balance'] = (Number(this.invoiceInfo.invoice_amount) - qutstandingBalance).toFixed(2);*/
                },
                (err: any) => {
                    this.showErrorFun(err.response.data.message);
                }
            );
    }

    tagFoldBody(foldNmae: any) {
        if (this.foldBody == foldNmae) this.foldBody = 0;
        else this.foldBody = foldNmae;
    }

    viewPdf(url: string) {
        if (url) {
            window.open(url);
        }
    }

    goInvoicesListPage() {
        this.$router.replace({
            name: 'Invoices',
        });
    }

    closeTips() {
        this.showErrTip = false;
    }

    showErrorFun(errText: any) {
        this.errorText = errText;
        this.showErrTip = true;
        setTimeout(() => {
            this.showErrTip = false;
        }, 3000);
    }

    payInvoiceFun() {
        if (this.payInvoice.length >= 1) {
            this.payInvoice = [];
        }
        this.payInvoice.push(this.invoiceInfo);
        this.payOptionVal = 1;
        this.$modal.show(this.editProductModal);
    }

    chargeSuccess() {
        this.closeModal();
        this.$router.go(0);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/viewShipment/index.ts